module.exports = __webpack_public_path__ + "img/Dantam Makeover 20.e9bd3b06.jpg";